import React from 'react'
import PensionAnnuity from '../components/pension/PensionAnnuity'
import Irp from '../components/pension/Irp'
import DrawDown from '../components/pension/DrawDown'

function Pension() {
  return (
    <div>
      <Irp/>
      <PensionAnnuity/>
      <DrawDown/>



    </div>
  )
}

export default Pension